module.exports = __webpack_public_path__ + "static/second_mockup_wyborek_small-710ce02b50b072db1c6534e99dca73d4.png";